import classNames from 'classnames';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import styles from './Spinner.module.scss';
export interface UI_SpinnerProps {
	style?: 'large' | 'slow' | 'error';
	loadingLabel?: string;
}

export const UI_Spinner = ({ style, loadingLabel }: UI_SpinnerProps) => (
	<UI_Container width="Standard">
		<div className={classNames(styles.Spinner_screenReader, styles.Spinner_loadingMsg)} role="alert">
			{loadingLabel}
		</div>
		<div className={classNames(styles.Spinner, styles[`Spinner___${style}`])} aria-hidden="true"></div>
	</UI_Container>
);
